import React, { useState, useEffect } from 'react';
import Menu from '../menu/Menu';
import Table from '../common/Table';
import RTSpinner from '../common/RTSpinner';
import RTButton from '../common/RTButton';
import { apiGet } from '../../api/apiClient';
import { navigateToPath } from '../../utils/navigationHelper';
import { formatDateToDDMMYYYY } from '../../utils/dateHelper';
import './ViewAllocatedBeds.css';

const ViewSoonVacatingBeds = () => {
  const [loading, setLoading] = useState(true);
  const [allocations, setAllocations] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch soon vacating allocation data
      const allocationResponse = await apiGet('/allocation/soon-vacating');
      setAllocations(allocationResponse.data);

    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to load soon vacating beds data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePGClick = (pgId) => {
    window.open(`/paying-guest/view/${pgId}`, '_blank');
  };

  const handleBuildingClick = (buildingId) => {
    window.open(`/building/view/${buildingId}`, '_blank');
  };

  const handleViewAllocation = (allocationId) => {
    navigateToPath(`/bedallocation/allocation/${allocationId}`);
  };

  // Define table columns
  const columns = [
    {
      Header: 'Days Until Vacating',
      accessor: 'days_until_vacation',
      Cell: ({ value }) => (
        <span className={value <= 7 ? 'urgent-vacation' : value <= 15 ? 'warning-vacation' : ''}>
          {value} days
        </span>
      )
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'End Date',
      accessor: 'end_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'Notice Date',
      accessor: 'notice_date',
      Cell: ({ value }) => value ? formatDateToDDMMYYYY(value) : 'N/A'
    },
    {
      Header: 'PG Name',
      accessor: 'pg_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handlePGClick(row.pg_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Building',
      accessor: 'building_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handleBuildingClick(row.building_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Room',
      accessor: 'room_type'
    },
    {
      Header: 'Rent Amount',
      accessor: 'rent_amount',
      Cell: ({ value }) => value ? `₹${value.toLocaleString()}` : 'N/A'
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <RTButton
          type="link"
          onClick={() => handleViewAllocation(row.allocation_id)}
          style={{ fontWeight: 'bold' }}
        >
          View
        </RTButton>
      )
    }
  ];

  if (loading) {
    return <RTSpinner message="Loading soon vacating beds data..." fullScreen={true} />;
  }

  return (
    <div className="rt-layout">
      <Menu />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Vacating Soon</h2>
          <div className="rt-actions">
            <RTButton variant="secondary" onClick={() => window.history.back()}>
              &#8592; Back
            </RTButton>
          </div>
        </div>

        {error && (
          <div className="rt-error-message">
            {error}
            <RTButton 
              type="primary" 
              onClick={fetchData}
              style={{ marginLeft: '10px' }}
            >
              Retry
            </RTButton>
          </div>
        )}

        {/* Allocation Details Table */}
        <div className="rt-table-section">
          <Table
            title={`Soon Vacating Beds Details (${allocations.length} Total)`}
            columns={columns}
            data={allocations}
            showSearch={true}
            exportable={true}
            showPagination={true}
            noDataText="No beds are vacating in the next 30 days."
            pageSize={20}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewSoonVacatingBeds;
